<template lang="pug">
//- for mobile view
second-menu(:selectorid="'tab-selector-year'",
            :tabs="tabs",
            :synctab.sync="tab",
            :isshadow="false")

.banner.bg-cover.visible-xs
section.pt0
  .container
    #year-selector-dropdown.row
      .col-xs-12
        .menus.dropdown
          #dLabel(type='button', data-toggle='dropdown', aria-haspopup='true', aria-expanded='false')
            h4 {{tab}} &gt;
          ul.dropdown-menu(aria-labelledby='dLabel')
            li(v-for="tab in tabs" @click='changeTab(tab)')
              a {{tab.title}}
    .row
      .col-xs-12
        .media(v-for="row in rows")
          .media-left
            a(':href'="row.link" target="_blank")
              img.media-object(':src'="row.thumbnail_image | resource")
          .media-body.media-middle
            h4.media-heading.hidden-xs
              a(':href'="row.link" target="_blank") {{row.name | multilang}} &nbsp; | &nbsp; {{row.date | moment 'D MMMM YYYY'}}
            p {{row.title | multilang}}
            h4.media-heading.visible-xs
              div
                a(':href'="row.link" target="_blank") {{row.name | multilang}}
              div
                a(':href'="row.link" target="_blank") {{row.date | moment 'D MMMM YYYY'}}
</template>

<script>
import axios from 'axios'
import SecondMenu from '../second-menu.vue'

export default {
  data () {
    return {
      tabs_url: '/api/media/years',
      url: '/api/media',
      data:{},
      rows: [],
      tab: '',
      tabs: [],
    }
  },
  created () {
    axios.get(this.tabs_url)
      .then((response) => {
        const data = response.data
        let tabs = []
        for(var i in data.results)
          tabs.push( {title: data.results[i], id: data.results[i]} )
        this.tabs = tabs
        this.tab = this.tabs[0].id
      })
      .catch((err) => console.log(err))

  },
  ready () {},
  watch: {
    tab(val) {
      axios.get(this.url, {params: {year: val}})
      .then((response) => {
        const data = response.data
        this.rows = response.data.results
      })
    }
  },
  methods: {
    changeTab(val) {
      this.tab = val.id
    },
  },
  components: {
    SecondMenu
  },
}
</script>

<style lang="scss" scoped>
@import "global";

.menus {
  h4 {
    font-size: 20px;
  }
  margin-bottom: 30px;
}

.media {
  @media(max-width: #{$screen-xs-max}) {
    margin-top: 18px;
    padding-bottom: 17px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
  }
}

.media-left {
  @media(max-width: #{$screen-xs-max}) {
    padding-right: 16px;
  }
  padding-right: 85px;
}

.media-heading {
  div {
    @media(max-width: #{$screen-xs-max}) {
      height: 16px;
    }
  }
  a {
    @media(max-width: #{$screen-xs-max}) {
      font-size: 12px;
    }
    font-size: 16px;
    color: #6a869c;
  }
}

.media-body {
  font-weight: bold;
  font-size: 20px;
  p {
    @media(max-width: #{$screen-xs-max}) {
      margin: 0 0 5px;
      height: 19px;
      font-size: 14px;
      overflow: hidden;
    }
  }
}

.media-object {
  width: 110px;
  height: 110px;
  @media(max-width: #{$screen-xs-max}) {
    width: 60px;
    height: 60px;
  }
  background-color: gray;
  border-radius: 220px;
}

.banner {
  height: 166px;
  background-image: url('../../images/news/2-3_3_News_Media.jpg');
  @media(max-width: #{$screen-xs-max}) {
    margin-bottom: 28px;
  }
}

a {
  cursor: pointer;
}

section.pt0 {
  @media(min-width: #{$screen-md-min}) {
    padding-left: 200px;
  }
}
</style>

<style lang="scss">
#tab-selector-year {
  display: none;
}
</style>



// WEBPACK FOOTER //
// media.vue?56b74408